function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var KeniaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#0067C3",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#272727",
      fillRule: "evenodd",
      d: "M0 3v6h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#4E8B1D",
      fillRule: "evenodd",
      d: "M0 15v6h24v-6H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E31D1C",
      stroke: "#F7FCFF",
      d: "M0 8.5h-.5v7h25v-7H0Z"
    })]
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M14.718 4.03c.17-.41.631-.859 1.381-1.345a.079.079 0 0 1 .083-.003c.045.026.064.09.042.141L8.456 21.452l-.405-.231L14.9 4.8c-.31-.06-.37-.316-.181-.77Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M9.274 4.03c.19.455.13.711-.18.77l6.847 16.42-.405.232L7.768 2.823c-.022-.052-.003-.115.041-.14a.079.079 0 0 1 .084.002c.75.486 1.21.935 1.381 1.345Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#E31D1C",
    fillRule: "evenodd",
    d: "M12 20.947c.897 0 4.5-3.77 4.5-8.42 0-4.652-3.603-8.422-4.5-8.422-.897 0-4.5 3.77-4.5 8.421s3.603 8.421 4.5 8.421Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("mask", {
    id: "b",
    width: "10",
    height: "17",
    x: "7",
    y: "4",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M12 20.947c.897 0 4.5-3.77 4.5-8.42 0-4.652-3.603-8.422-4.5-8.422-.897 0-4.5 3.77-4.5 8.421s3.603 8.421 4.5 8.421Z",
      clipRule: "evenodd"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#b)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#272727",
      d: "M20.25 19.895c3.48 0 6.3-3.3 6.3-7.369 0-4.07-2.82-7.368-6.3-7.368s-6.3 3.299-6.3 7.368c0 4.07 2.82 7.369 6.3 7.369ZM3.75 19.895c3.48 0 6.3-3.3 6.3-7.369 0-4.07-2.82-7.368-6.3-7.368s-6.3 3.299-6.3 7.368c0 4.07 2.82 7.369 6.3 7.369Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M12.18 11.4c.41-.341.72-1.828.72-3.61 0-1.783-.31-3.27-.72-3.611V11.4Zm-.45-.095c-.365-.47-.63-1.866-.63-3.516s.265-3.046.63-3.515v7.031Zm0 2.443v7.03c-.365-.469-.63-1.865-.63-3.515 0-1.65.265-3.046.63-3.515Zm.45 7.126v-7.221c.41.341.72 1.828.72 3.61 0 1.782-.31 3.27-.72 3.61Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M12 11.474c.497 0 .9.471.9 1.052 0 .582-.403 1.053-.9 1.053s-.9-.471-.9-1.053c0-.581.403-1.052.9-1.052Z"
    })]
  })]
}));
//# sourceMappingURL=Kenia.js.map